<template>
  <div class="pagination_box">
    <!-- @size-change="handleSizeChange" -->
    <!-- :page-sizes="[60, 120, 240]" -->
    <!-- layout="sizes, prev, pager, next"  -->
    <el-pagination class="list_pagination" :class="[ifF_end?'justify-c':'']" background @current-change="handleCurrentChange" :current-page.sync="PageIndex" :page-size="PageSize" layout="prev, pager, next" :total="total" v-if="total > 0">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "pagination",
  props: {
    total: {
      type: Number,
      default: 0
    },
    PageSize: {
      type: Number,
      default: 60
    },
    ifF_end: {
      type: Boolean,
      default: false
    }
    // total: 0,
    // PageSize: 60,
    // ifF_end: false
  },
  data() {
    return {
      PageIndex: 1,
    };
  },
  methods: {
    // handleSizeChange(val) {
    //   this.PageSize = val;
    //   this.$emit('getData', this.PageIndex, this.PageSize);
    //   console.log(`每页 ${val} 条`);
    // },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.$emit('getData', this.PageIndex, this.PageSize);
      console.log(`当前页: ${val}`);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.justify-c {
  justify-content: flex-end !important;
}
.pagination_box {
  margin-top: 30px;
  display: flex;
}

.list_pagination {
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  font-weight: 400;
}

.list_pagination .el-pagination__sizes {
  position: absolute;
  right: 0px;
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  border: 1px solid #f0f0f0;
  background-color: #fff;
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev {
  background-color: #f0f0f0;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #5f6dae;
}

.el-pagination.is-background .el-pager li:not(.active):hover {
  color: #5f6dae;
}

.el-pagination__sizes .el-input .el-input__inner:hover {
  border-color: #c8c8c8;
}
</style>



// WEBPACK FOOTER //
// src/components/listpagination.vue